import {
    EnglishProficiencyTests,
    FrenchProficiencyTests,
    VisaApplicationStepName,
    VisaPurposes,
} from 'constant';

export const General_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        VisaApplicationStepName['Personal Info'],
        //'Visa Purpose',
        VisaApplicationStepName['Additional Details'],
        `${hasSpouse === 'Yes' ? VisaApplicationStepName['Spouse/Common Law Partner'] : ''}`,
        //`${hasFamily === 'Yes' ? VisaApplicationStepName['Family Members'] : ''}`,
        VisaApplicationStepName['Family Members'],
        VisaApplicationStepName['Language Proficiency'],
        VisaApplicationStepName['Education'],
        VisaApplicationStepName['Work Experience'],
        VisaApplicationStepName['Job Offer'],
        VisaApplicationStepName['Relatives Abroad'],
        VisaApplicationStepName['Business Ownership'],
    ];
};

export const Travel_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        VisaApplicationStepName['Personal Info'],
        VisaApplicationStepName['Additional Details'],
        `${hasSpouse === 'Yes' ? VisaApplicationStepName['Spouse/Common Law Partner'] : ''}`,
        `${hasFamily === 'Yes' ? VisaApplicationStepName['Family Members'] : ''}`,
    ];
};

export const Work_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        VisaApplicationStepName['Personal Info'],
        VisaApplicationStepName['Additional Details'],
        `${hasSpouse === 'Yes' ? VisaApplicationStepName['Spouse/Common Law Partner'] : ''}`,
        `${hasFamily === 'Yes' ? VisaApplicationStepName['Family Members'] : ''}`,
        VisaApplicationStepName['Language Proficiency'],
        VisaApplicationStepName['Education'],
        VisaApplicationStepName['Work Experience'],
        VisaApplicationStepName['Job Offer'],
        VisaApplicationStepName['Relatives Abroad'],
        VisaApplicationStepName['Business Ownership'],
    ];
};

export const Business_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        VisaApplicationStepName['Personal Info'],
        VisaApplicationStepName['Additional Details'],
        `${hasSpouse === 'Yes' ? VisaApplicationStepName['Spouse/Common Law Partner'] : ''}`,
        `${hasFamily === 'Yes' ? VisaApplicationStepName['Family Members'] : ''}`,
        VisaApplicationStepName['Language Proficiency'],
        VisaApplicationStepName['Education'],
        VisaApplicationStepName['Work Experience'],
        VisaApplicationStepName['Business Ownership'],
    ];
};

export const Study_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        VisaApplicationStepName['Personal Info'],
        VisaApplicationStepName['Additional Details'],
        `${hasSpouse === 'Yes' ? VisaApplicationStepName['Spouse/Common Law Partner'] : ''}`,
        `${hasFamily === 'Yes' ? VisaApplicationStepName['Family Members'] : ''}`,
        VisaApplicationStepName['Language Proficiency'],
        VisaApplicationStepName['Education'],
        VisaApplicationStepName['Work Experience'],
    ];
};

const getArrayValues = (arr: string[]) => {
    return arr.filter((el) => el !== '');
};

export const getVisaApplicationPath = (purpose: string, hasSpouse?: string, hasFamily?: string) => {
    switch (purpose) {
        case VisaPurposes.TRAVEL:
            return getArrayValues(Travel_path(hasSpouse, hasFamily));
        case VisaPurposes.WORK:
            return getArrayValues(Work_path(hasSpouse, hasFamily));
        case VisaPurposes.BUSINESS:
            return getArrayValues(Business_path(hasSpouse, hasFamily));
        case VisaPurposes.STUDY:
            return getArrayValues(Study_path(hasSpouse, hasFamily));
        case VisaPurposes.GENERAL:
            return getArrayValues(General_path(hasSpouse, hasFamily));
        case VisaPurposes.NOPREFERENCE:
            return getArrayValues(General_path(hasSpouse, hasFamily));
        default:
            return getArrayValues(Travel_path(hasSpouse, hasFamily));
    }
};

export function generatePointsArray(size: number, start: number) {
    return [''].concat(Array.from({ length: size }, (_, index) => String(index + start)).reverse());
}

export const getLanguageScores = (testType: string) => {
    if (testType === EnglishProficiencyTests.IELTS) {
        return generatePointsArray(1, 9);
    } else if (testType === EnglishProficiencyTests.CELPIP) {
        return generatePointsArray(1, 12);
    } else if (testType === EnglishProficiencyTests.TOEFL) {
        return generatePointsArray(1, 30);
    } else if (testType === EnglishProficiencyTests.CEFR) {
        return generatePointsArray(1, 6);
    } else if (testType === FrenchProficiencyTests.TEF) {
        return generatePointsArray(121, 294);
    } else if (testType === FrenchProficiencyTests.TCF) {
        return generatePointsArray(100, 600);
    } else {
        return generatePointsArray(1, 9);
    }
};

export const getLanguageScoreRange = (testType: string) => {
    if (testType === EnglishProficiencyTests.IELTS) {
        return { min: 0, max: 9 };
    } else if (testType === EnglishProficiencyTests.CELPIP) {
        return { min: 0, max: 12 };
    } else if (testType === EnglishProficiencyTests.TOEFL) {
        return { min: 0, max: 30 };
    } else if (testType === EnglishProficiencyTests.CEFR) {
        return { min: 0, max: 6 };
    } else if (testType === FrenchProficiencyTests.TEF) {
        return { min: 121, max: 294 };
    } else if (testType === FrenchProficiencyTests.TCF) {
        return { min: 100, max: 600 };
    } else {
        return { min: 0, max: 9 };
    }
};

/** CEFR band labels used on score sliders (matches LanguageFormV2). */
export const CEFR_SCALE: Record<number, string> = {
    6: 'C2',
    5: 'C1',
    4: 'B2',
    3: 'B1',
    2: 'A2',
    1: 'A1',
};

/** Slider step for a given proficiency test type. */
export const getLanguageScoreStep = (testType: string) => {
    if (testType === EnglishProficiencyTests.IELTS) {
        return 0.5;
    }
    return 1;
};

export const formatLanguageScoreLabel = (testType: string, value: number) => {
    if (testType === EnglishProficiencyTests.CEFR) {
        return CEFR_SCALE[value] || value;
    }
    return value;
};

export const getMarkerOptions = ({ min, max }: { min: number; max: number }) => {
    const result = Array.from({ length: max - min + 1 }, (_, index) => {
        const value = index + min;
        return {
            value: value,
            label: index === 0 || value === max ? String(value) : '',
        };
    });

    return result;
};
